interface HelpPage {
  tab: number
  label: string
  language: string
  content: string
  title?: string
  sections?: string[]
  [key: string]: string | number | string[] | undefined
}

const getSubheaders = (obj: HelpPage) =>
  (obj.content.match(/^## +.*/gm) ?? []).map(line => line.replace(/^## */, ''))

const requireMarkdown = () => {
  // use webpack require.context to dynamically load translations from files
  const req = require.context('.', true, /.*\.md$/)
  // pattern: ./<language>/<tab>.<label>.md
  // example: ./nb/01.psykometri.md
  const pattern = /\/(\w+)\/(\d+)\.(.+)\.md$/
  return req.keys().reduce(
    (acc, key) => {
      const [language, tab, label] = key.match(pattern)!.slice(1)
      let match
      if (!acc[language]) acc[language] = []
      const obj: HelpPage = {
        tab: parseInt(tab),
        label: label.replace(/_/g, ' '),
        language,
        content: req(key).default || req(key),
      }
      acc[language][obj.tab] = obj
      const lines = obj.content.split(/\n/g)
      for (let i = 0; i < lines.length; i++) {
        const line = lines[i]
        if (line.trim() === '') continue
        const match = line.match(/^(\w+):(.*?)$/)
        if (match) {
          obj[match[1]] = match[2].trim()
        } else {
          obj.content = lines.slice(i - 1).join('\n')
          break
        }
      }

      const titleRegex = /^\s*#([^#].*?)\n+(.*)/s
      if ((match = titleRegex.exec(obj.content))) {
        obj.title = match[1].trim()
        obj.content = match[2].trim()
      }
      obj.sections = getSubheaders(obj)
      return acc
    },
    {} as Record<string, HelpPage[]>,
  )
}

export default requireMarkdown()
